import { createContext } from 'react';

interface UsageStats {
  links: { current: number; limit: number };
  qr_codes: { current: number; limit: number };
}

interface User {
  id: string;
  email: string;
  tier: string;
  usage?: UsageStats;
}

export interface AuthContextType {
  user: User | null;
  token: string | null;
  rememberMe: boolean;
  isLoading: boolean;
  isAuthenticated: boolean;
  login: (email: string, password: string, rememberMe?: boolean) => Promise<void>;
  register: (email: string, password: string) => Promise<{ message: string; email: string }>;
  googleAuth: () => Promise<void>;
  logout: () => void;
  error: string | null;
  clearError: () => void;
  refreshActivity: () => void;
  requestPasswordReset: (email: string) => Promise<{ message: string; email: string }>;
  resetPassword: (token: string, password: string) => Promise<{ message: string; email: string }>;
}

export const AuthContext = createContext<AuthContextType | undefined>(undefined);